<template>
  <v-card height="100%">
    <v-card-title>Tariff Details</v-card-title>
    <v-card-text>This product uses a legacy tariff, please use the old CRM to view the tariff</v-card-text>
  </v-card>
</template>

<script>
export default {

}
</script>

<style>

</style>